module.exports = __webpack_public_path__ + "img/swiperThree.4e39c9fd.png";